import { render } from "./SoftwaresCreate.vue?vue&type=template&id=5a473bd1"
import script from "./SoftwaresCreate.vue?vue&type=script&lang=js"
export * from "./SoftwaresCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__